import { isAfishaPath } from "./cinemaSlugs"

/** Страницы, на которых показываем уведомление о неоплаченном билете */
export function isUnpaidTicketNoticePath(pathname: string): boolean {
    if (isAfishaPath(pathname)) return true
    if (pathname === "/buy") return true
    return false
}
